import { RouteName } from '@/configuration/route/route-names'
import { ReportType } from '@/configuration/report/report-types'
import { ComponentType } from '@/configuration/component/component-types'
import { useRouter } from 'vue-router'
import { toValue, type MaybeRefOrGetter } from 'vue'
import { AnalysisType } from '@/configuration/analysis/analysis-types'

export const useGeneratorVisualInspectionTableRoutes = (generatorId: MaybeRefOrGetter<string | undefined>) => {
    const router = useRouter()
    const isValidGeneratorId = (id?: string) => !!id

    const openReport = (analyticalNumber: string) => {
        const id = toValue(generatorId)

        if (!isValidGeneratorId(id)) {
            return
        }

        router.push({
            name: RouteName.GeneratorsReportsViewCondition,
            params: {
                componentSid: id,
                componentType: String(ComponentType.Generator),
                reportNumber: analyticalNumber,
                reportType: String(ReportType.GeneratorStatusReport),
            },
            query: {
                focused: AnalysisType.VisualInspection,
            },
        })
    }

    const onViewImagesClick = (reportNumber: string) => {
        const id = toValue(generatorId)

        if (!isValidGeneratorId(id)) {
            return
        }

        router.push({
            name: 'Reports_Images_View',
            params: {
                componentSid: id,
                reportNumber: reportNumber,
                reportType: ReportType.GeneratorStatusReport,
            },
            query: {
                focused: AnalysisType.VisualInspection,
            },
        })
    }

    return {
        openReport,
        onViewImagesClick,
    }
}
